<template>
<div class="product-slider">
  <div class="product-slider__container">
    <slider-controls @prev="slide('prev')" @next="slide('next')" :disabled="disabled" />

    <transition-group class="product-slider__list" tag="ul" name="list"
     @before-enter="beforeCb" @after-enter="afterCb">

      <template v-if="page === 'classWay'">
        <slider-items v-for="(productItem, index) in slidesSlides"
        :key="`${productItem.category}-${index}`" :productItem="productItem" />
      </template>

      <template v-else>
        <slider-items v-for="productItem in slidesSlides"
        :key="productItem.path" :productItem="productItem" />
      </template>

    </transition-group>
  </div>
</div>
</template>

<script>
import SliderItems from '@/components/products/SliderItems.vue';
import SliderControls from '@/components/products/SliderControls.vue';

export default {
  components: {
    SliderItems,
    SliderControls,
  },
  props: {
    page: {
      type: String,
      default() {
        return '';
      },
    },
    productItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mainPage: false,
      window: {
        width: 0,
      },
      disabled: false,
      productList: this.productItems,
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    slidesSlides() {
      if (this.window.width <= 580 && this.page === 'classWay') {
        return [...this.productList].splice(0, 2);
      }
      if (this.window.width <= 580) {
        return [...this.productList].splice(0, 1);
      }
      if (this.window.width <= 635 && this.page === 'classWay') {
        return [...this.productList].splice(0, 2);
      }
      if (this.window.width <= 820) {
        return [...this.productList].splice(0, 2);
      }
      if (this.window.width <= 825 && this.page === 'classWay') {
        return [...this.productList].splice(0, 3);
      }
      if (this.window.width >= 825 && this.page === 'classWay') {
        return [...this.productList].splice(0, 4);
      }
      return [...this.productList].splice(0, 3);
    },
  },
  methods: {
    beforeCb() {
      this.disabled = true;
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
    slide(direction) {
      const lastItem = this.productList[this.productList.length - 1];
      switch (direction) {
        case 'next':
          this.productList.push(this.productList[0]);
          this.productList.shift();
          break;
        case 'prev':
          this.productList.unshift(lastItem);
          this.productList.pop();
          break;
        default:
      }
    },
    afterCb() {
      this.disabled = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-slider {

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 94%;
    position: relative;
    margin: 0 auto;

    @media (max-width: 1275px) {
      padding: 40PX 50px 0;
    }

    @media (max-width: 980px) {
      .class-ways__slider & {
        padding: 0;
        width: 100%;
      }
    }

    @media (max-width: 720px) {
      width: 100%;
    }

    @media (max-width: 490px) {
      padding: 30px;
    }
  }

  &__list {
    display: flex;
    justify-content: space-between;
    width: 91%;
    height: 100%;

    .class-ways__slider & {
      justify-content: flex-start;
      width: 100%;
    }

    @media (max-width: 825px) {
      .class-ways__slider.coral & {
        justify-content: center;
      }
    }

    @media (max-width: 820px) {
      width: 100%;
    }

    @media (max-width: 635px) {
      .class-ways__slider.blue &,
      .class-ways__slider.coral & {
        justify-content: space-evenly;
      }
    }

    @media (max-width: 580px) {
      justify-content: center;
    }
  }
}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all .2s ease-out;
}

.list-enter-to,
.list-leave-to {
  opacity: 1;
}

.list-enter-from,
.list-leave-from {
  opacity: 0;
  transform: translateX(30px);
}

.list-leave-active {
  position: absolute;
  transform: translateY(30px);
  opacity: 0;
}
</style>
